module.exports = __webpack_public_path__ + "media/images/placeholder-survey-d9c715cb.png";